import axios from 'axios';
import { useQueryClient, useQuery } from '@tanstack/react-query';
import { fetchDefault, fetchFormAuth, setError } from 'src/fetch/common';
import { myInfo, familyInfo } from 'src/static/sample/stepA';
import { dataSet, dataSetTotal, familyDataSet } from './dataSet';
import { error } from 'console';

const stateTimeStr = process.env.REACT_APP_REACTQUERY_STALETIME || '0';
const STALETIME = Number(stateTimeStr);

/**
 * Fetch: StepA
 */
export const fetchData = async (
  param: any,
  errorModalState: any,
  salaryInfoStore: any,
  preworkInfoStore: any,
  myInfoDataState: any,
  loadingState: any,
  queryClient: any
) => {
  try {
    loadingState({ active: '_active' });
    await salaryInfoDataFn(errorModalState, param, salaryInfoStore, queryClient);
    await preworkInfoDataFn(errorModalState, param, preworkInfoStore, queryClient);
    await myInfoDataFn(errorModalState, param, myInfoDataState, queryClient);
    loadingState({ active: '' });
  } catch (e) {
    console.log('error:', e);
  }
};

const salaryInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/salaryinfo/sel';
  const fetchKey = 'SALARY_INFO';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    console.log('[SALARY_INFO]:', paramSet, data);
    const infoData: any = data;
    const { resError, resData } = dataSet(infoData, null);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }
  } catch (e) {
    console.log('error:', e);
  }
};

const preworkInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const initParam = {
    idx: 0,
    pnum: 1,
    pcnt: 100,
    keyword: '',
    sort_field: 'prev_co_num',
    sort_type: 'desc',
  };
  const paramSet = { ...initParam, ...param };
  const fetchUrl = '/api/preworks/lst';
  const fetchKey = 'PREWORK_LIST';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    // const infoData: any = myInfo;
    const infoData: any = data;
    const { resError, resData } = dataSetTotal(infoData, null);
    console.log('[PREWORK_LIST]:', paramSet, data, resData);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }
  } catch (e) {
    console.log('error:', e);
  }
};

const myInfoDataFn = async (
  errorModalState: any,
  param: any,
  initDataStore: any,
  queryClient: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/uif/sel';
  const fetchKey = 'MY_INFO';

  try {
    const data = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    console.log('[MY_INFO]:', paramSet, data);

    const infoData: any = data;
    const { resError, resData } = dataSet(infoData, null);

    if (resError.type === 'error') {
      errorModalState({ data: resError, active: '_active' });
    } else {
      initDataStore({ data: resData });
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/*
 * Insert 종전근무지 추가
 */

export const fetchInsertPreworkData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/preworks/ist';
  const fetchKey = 'PREWORKS_INSERT';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/*
 * UPDATE 종전근무지 수정
 */

export const fetchUpdatePreworkData = async (
  param: any,
  queryClient: any,
  errorModalState: any,
  loadingState: any,
  callback: any
) => {
  const paramSet = param;
  const fetchUrl = '/api/preworks/upd';
  const fetchKey = 'PREWORKS_UPDATE';

  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: [fetchKey],
      queryFn: () => fetchDefault(paramSet, fetchUrl),
    });
    loadingState({ active: '' });

    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      errorModalState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};

/**
  Delete 종전근무지 삭제
*/
export const fetchDeletePreworkData = async (
  paramData: any,
  queryClient: any,
  setErrorState: any,
  loadingState: any,
  callback: any
) => {
  try {
    loadingState({ active: '_active' });
    const queryData = await queryClient.fetchQuery({
      queryKey: ['PREWORKS_DELETE', paramData],
      queryFn: () => fetchDefault(paramData, '/api/preworks/del'),
    });
    loadingState({ active: '' });
    const errorSet = setError(queryData, null);
    if (errorSet.type === 'error') {
      console.log('ERROR');
      setErrorState({ data: errorSet, active: '_active' });
    } else {
      callback();
    }
  } catch (e) {
    console.log('error:', e);
  }
};
